import { all, call, fork, put, takeLatest, select } from 'redux-saga/effects';
import i18n from 'i18next';

import { FETCH_UNIT_DETAILS } from '../constants/ActionTypes';

import { showError } from '../actions/Common';
import { CustomAction } from 'model/state';
import {
  UnitPayload, fetchUnitDetailsSuccess, fetchUnitDetailsError,
} from 'actions';
import { getLocationById } from 'api/Location';
import { toUnit } from 'model/api';
import { selectUserUnitSystem, selectUserId } from 'selectors';
import { UnitSystem } from 'model';

function* fetchUnitDetailsWorker(action: CustomAction<UnitPayload>) {
  const unitId = action.payload?.unitId;
  try {
    if (!unitId) {
      throw Error('Invalid Parameters');
    }
    const unit = yield call(getLocationById, unitId, ['devices', 'parent']);

    const userUnitSystem = yield select(selectUserUnitSystem());
    const authUserId = yield select(selectUserId());
    yield put(fetchUnitDetailsSuccess(toUnit(unit, userUnitSystem || UnitSystem.IMPERIAL, authUserId)));
  } catch (err) {
    yield put(fetchUnitDetailsError());
    yield put(showError(i18n.t('connection_error'), err));
  }
}

export function* fetchUnitDetailsSaga() {
  yield takeLatest(FETCH_UNIT_DETAILS, fetchUnitDetailsWorker);
}

export default function* rootSaga() {
  yield all([
    fork(fetchUnitDetailsSaga),
  ]);
}